const VideoDuration = ({ data }) => {
    return (
        <>
            <h5>{data?.videoDuration}</h5>
        </>
    )
}

export default VideoDuration